import { Typography } from "@/design-system/Atoms";
import { HowItWorksStepCard } from "@/design-system/Molecules";
import { TrimixWhyDefyMedStepCardData } from "@/design-system/Molecules/HowItWorksStepCard/stepCard.config";

export const TrimixWhyDefyMedSection = () => {
  return (     
    <section className="relative block pt-44 lg:pt-[176px]">
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-1/2">
            <div className="sticky top-0 mb-[3.125rem]">
              <div>
                <img
                  className="w-full object-cover"
                  src="/images/trimix/img-trimix-why.png"
                  alt="trimix-why"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-5/12 lg:ml-[8.333333%]">
            <Typography variant="categoryText" as="div" className="mb-10">
              Why Defy Medical
            </Typography>
            <Typography variant="sectionHeading" as="h2" className="mb-10">
              <>
                The Defy Medical{" "}
                <span className="text-gray-400">Difference</span>
              </>
            </Typography>
            <Typography
              variant="sectionDescriptionLarge"
              as="p"
              className="mb-10"
            >
              At Defy Medical, we’re redefining Men’s Health with personalized
              care and expert solutions. We’re committed to providing you with
              safe, effective treatments tailored to your lifestyle.
            </Typography>

            {TrimixWhyDefyMedStepCardData.map((step, idx) => (
              <HowItWorksStepCard
                key={idx}
                icon={step.icon ?? ""}
                title={step.title ?? ""}
                description={step.description ?? ""}
                className={step.className ?? ""}
              />
            ))} 
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrimixWhyDefyMedSection;
